import Helper from './Helper';

class AnchorScroll {

  constructor(config = {}) {
    const {
      containerSelector
    } = config;

    this.container = document.querySelectorAll(containerSelector);
    this.containerArray = Array.prototype.slice.call(this.container);
    this.maxContainers = 0;
    if (this.container) {
      this.maxContainers = this.containerArray.length;
      this.containerArray.forEach((container, index) => {
        this.addAnchor(container, index);
      });
    }
  }

  addAnchor(container, index) {
    const controls = container.querySelector('.ns-anchor-container__controls');
    const prev = controls.querySelector('.ns-anchor-container__button--prev');
    const current = controls.querySelector('.ns-anchor-container__current');
    const max = controls.querySelector('.ns-anchor-container__max');
    const next = controls.querySelector('.ns-anchor-container__button--next');

    current.innerHTML = index+1;
    max.innerHTML = this.maxContainers;

    if ( index > 0 ) {
      prev.addEventListener("click", (e) => {
        const id = index - 1;
        const scrollToElement = document.getElementById(id); //document.querySelector("#"+id);
        this.scrollTo(scrollToElement);
      });
    } else {
      Helper.addClass(prev, "disabled");
    }

    if ( index+1 < this.maxContainers ) {
      next.addEventListener("click", (e) => {
        const id = index + 1;
        const scrollToElement = document.getElementById(id); //document.querySelector("#"+id);
        this.scrollTo(scrollToElement);
      });
    } else {
      Helper.addClass(next, "disabled");
    }

    container.setAttribute('id', index);


  }

  scrollTo(element) {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: Helper.getRealOffsetTop(element) //- 150
    });
  }

}

export default AnchorScroll;
